export function clientPlatform() {
  if (typeof window === 'undefined') {
    return '';
  }
  if (window.innerWidth < 768) {
    return 'mobile';
  }
  return window.innerWidth < 1024 ? 'tablet' : 'desktop';
}
export function isMobile() {
  return clientPlatform() === 'mobile';
}
export function isTablet() {
  return clientPlatform() === 'tablet';
}
export function isDesktop() {
  return clientPlatform() === 'desktop';
}